import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatDate } from './utils';

interface DetailSection3Props {
  submission: CreditSubmission;
}

export default function DetailSection3({ submission }: DetailSection3Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>3. Data Pemohon</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-gray-600">Nama Lengkap</label>
            <p className="font-medium mt-1">{submission.debtor_name || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">NIK / No. KTP</label>
            <p className="font-medium mt-1">{submission.id_number || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Tempat Lahir</label>
            <p className="font-medium mt-1">{submission.birth_place || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Tanggal Lahir</label>
            <p className="font-medium mt-1">{formatDate(submission.birth_date)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Jenis Kelamin</label>
            <p className="font-medium mt-1">
              {submission.gender === 'male'
                ? 'Laki-laki'
                : submission.gender === 'female'
                  ? 'Perempuan'
                  : '-'}
            </p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Status Perkawinan</label>
            <p className="font-medium mt-1">{submission.marital_status || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Pendidikan</label>
            <p className="font-medium mt-1">{submission.education || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">No. Telepon</label>
            <p className="font-medium mt-1">{submission.phone || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Nama Ibu Kandung</label>
            <p className="font-medium mt-1">{submission.mother_maiden_name || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kontak Darurat</label>
            <p className="font-medium mt-1">{submission.emergency_contact || '-'}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
